import { render, staticRenderFns } from "./LoadingWave.vue?vue&type=template&id=0ef12956&scoped=true"
import script from "./LoadingWave.vue?vue&type=script&lang=js"
export * from "./LoadingWave.vue?vue&type=script&lang=js"
import style0 from "./LoadingWave.vue?vue&type=style&index=0&id=0ef12956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef12956",
  null
  
)

export default component.exports